export const AI_IMAGE_PROMPT_BOX_ID = 'toolbar-ai-generate-image-prompt-box';
export const AI_IMAGE_SUBMIT_LOADING_PULSE_MS = 1000;
export const AI_IMAGE_SETTINGS_POPUP_MAX_WIDTH = 308;
